import React, { useMemo, useState } from "react";
import RecordDotSvgIcon from "../../../../assets/icons/record";
import {
  Box,
  Button,
  Icon,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { handleUploadAudio } from "../../../../utils";
import FlatList from "flatlist-react/lib";
import OAuth from "../../../../artist/components/OAuth";
import UploadIcon from "@mui/icons-material/Upload";
import VoiceRecorder from "../../../../components/VoiceRecorder";
import { Close } from "@mui/icons-material";
import AudioPlayer from "../../../../components/AudioPlayer";

const VoiceNoteSection = ({ audios, onUpload, onRemove, isRenderOnModal }) => {
  const [isRecorderOpen, setIsRecorderOpen] = useState(false);

  const RecordButton = useMemo(() => {
    return (
      <Button
        onClick={() => setIsRecorderOpen(true)}
        className="flex flex-row gap-1 rounded-md justify-center items-center"
        sx={{
          border: "1px solid #E7EBF1",
          borderRadius: "8px",
          padding: "6px 12px",
          "&:hover": {
            backgroundColor: "transparent",
            border: "1px solid #E7EBF1",
          },
        }}
      >
        <RecordDotSvgIcon />
        <p className="text-[#687382] font-[10px]">Record Voice</p>
      </Button>
    );
  }, [isRecorderOpen]);

  const AudioFooterComponent = () => {
    return (
      <Stack direction={"row"} gap={2}>
        {RecordButton}
        <Button
          onClick={() => handleUploadAudio(onUpload)}
          className="flex flex-row gap-1 rounded-md justify-center items-center"
          sx={{
            border: "1px solid #E7EBF1",
            borderRadius: "8px",
            padding: "6px 12px",
            "&:hover": {
              backgroundColor: "transparent",
              border: "1px solid #E7EBF1",
            },
          }}
        >
          <Icon
            component={UploadIcon}
            sx={{ fontSize: 20, color: "#687382" }}
          />
          <p className="text-[#687382] font-[10px]">Upload Audio</p>
        </Button>
      </Stack>
    );
  };

  const renderItem = (item, index) => {
    if (!item) {
      console.error("Invalid item detected:", item);
      return null;
    }

    return (
      <Box key={index} sx={{ position: "relative", display: "inline-block" }}>
        <OAuth
          altSrc={URL.createObjectURL(item)}
          component={<AudioPlayer url={URL.createObjectURL(item)} />}
        />
        <IconButton
          sx={{
            position: "absolute",
            top: -7,
            right: -4,
            background: "#F3F3F3",
            width: 18,
            height: 18,
            zIndex: 10,
          }}
          size="small"
          onClick={() => onRemove(index)}
        >
          <Close sx={{ fontSize: "12px" }} />
        </IconButton>
      </Box>
    );
  };

  const ListEmpty = () => {
    return (
      <div className="text-center text-[16px] font-['Poppins-Medium']"></div>
    );
  };

  const AUDIO_RENDER_LIST = useMemo(
    () => (
      <FlatList
        key={"REFERENCE-AUDIOS-LIST"}
        list={audios}
        renderItem={renderItem}
        renderWhenEmpty={ListEmpty}
      />
    ),
    [audios, isRecorderOpen]
  );

  return (
    <Box>
      <Typography variant="h6">Voice Note</Typography>
      <Box flexGrow={1} mt={2}>
        {AUDIO_RENDER_LIST}
      </Box>
      <div className="mt-1">
        <AudioFooterComponent />
      </div>
      <VoiceRecorder
        open={isRecorderOpen}
        onClose={() => setIsRecorderOpen(false)}
        onSubmit={(data) => {
          console.log("Submitting audio:", data);

          const mimeType = data.type;
          const fileExtension = mimeType === "audio/mp4" ? "m4a" : "webm";

          const audioFile = new File(
            [data],
            `audio-${Date.now()}.${fileExtension}`,
            {
              type: mimeType,
            }
          );

          console.log("audioFile----->>>:", audioFile);
          onUpload([audioFile]);
        }}
      />
    </Box>
  );
};

export default VoiceNoteSection;
